import { Directive, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { HrCurrentFormKeys } from '../../service/hr-current-form-keys.service';

@Directive()
export class HrBaseElementComponent implements OnInit, OnChanges {
    @Input() name: string;
    @Input() label: string;
    @Input() disabled?: boolean;
    @Input() idPrefix: string;
    @Input() formGroupParam: UntypedFormGroup;
    inputId: string;

    formGroup: UntypedFormGroup;

    constructor(private currentFormKeys: HrCurrentFormKeys, private frmGrpDirective: FormGroupDirective) {}

    ngOnInit(): void {
        this.setFormGroup();
        this.setInputId(this.idPrefix);
        this.setDisabled(this.disabled);
        this.currentFormKeys.add(this.name, this.label);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.disabled != null && changes.disabled.previousValue !== changes.disabled.currentValue) {
            this.setDisabled(changes.disabled.currentValue);
        } else if (changes.idPrefix != null && changes.idPrefix.previousValue !== changes.idPrefix.currentValue) {
            this.setInputId(changes.idPrefix.currentValue);
        }
    }

    private setInputId(idPrefix: string) {
        this.inputId = idPrefix + '_' + this.name;
    }

    public setDisabled(dsb: boolean) {
        if (dsb) {
            this.formGroup.controls[this.name].disable();
        } else {
            this.formGroup.controls[this.name].enable();
        }
    }

    private setFormGroup() {
        this.formGroup = this.frmGrpDirective.form;
        if (this.formGroupParam != null) {
            this.formGroup = this.formGroupParam;
        }
    }
}
